const MAIN_PANEL_GUTTER = 'main-panel-gutter';
const CHATS_PANEL_GUTTER = 'chats-panel-gutter';

const MAIN_PANEL_ID = 'myConvoPanel';
const CHATS_PANEL_ID = 'all-chats-panel-resizable';
const CURRENT_CHAT_SECTION_ID = 'current-chat-section';


const chatsPane = document.getElementById(CHATS_PANEL_ID);
const mainPane = document.getElementById(MAIN_PANEL_ID);

const mainGutter = document.getElementById(MAIN_PANEL_GUTTER);
const chatsGutter = document.getElementById(CHATS_PANEL_GUTTER);

const currentChatSection = document.getElementById(CURRENT_CHAT_SECTION_ID);

export function getChatLayoutDimensions() {
    const raw = localStorage.getItem("@chat-layout") ?? "{}"
    return JSON.parse(raw)
}


export function setChatLayoutDimensions(layout){
    localStorage.setItem('@chat-layout',JSON.stringify(layout))
}


export function setInitialChatLayoutDimensions(){
    const layout = getChatLayoutDimensions();
    const main = Math.max(500,layout.main ?? (window.innerWidth/2) - 400);
    mainPane.style.width = main + "px";
    mainPane.style.left = "-"+ (main+5) + "px";
    const chats = Math.max(180,layout.chats ?? main * 0.34);
    chatsPane.style.width = chats + "px";

    const currentChat = main - chats;
    currentChatSection.style.width = currentChat + "px"
}


function mainPanelResizer(e) {

  window.addEventListener('mousemove', mousemove);
  window.addEventListener('mouseup', mouseup);

  let prevX = e.x;
  const mainPanel = mainPane.getBoundingClientRect();
  const chatsPanel = chatsPane.getBoundingClientRect();
  console.log("Chats panel",chatsPanel)
  mainPane.classList.add('resizing');
  let mainPanelWidth = mainPanel.width;
  function mousemove(e) {
    let newX = prevX - e.x;
    mainPanelWidth = Math.max(500,mainPanel.width - newX);
    mainPane.style.width = mainPanelWidth + "px";
    currentChatSection.style.width = (mainPanelWidth - chatsPanel.width) + "px"
  }

  function mouseup() {
    const layout = getChatLayoutDimensions();
    setChatLayoutDimensions({
        ...layout,
        main: mainPanelWidth
    })
    mainPane.classList.remove('resizing');
    window.removeEventListener('mousemove', mousemove);
    window.removeEventListener('mouseup', mouseup);

  }
}


function chatsPanelResizer(e) {

    window.addEventListener('mousemove', mousemove);
    window.addEventListener('mouseup', mouseup);

    let prevX = e.x;

    const chatsPanel = chatsPane.getBoundingClientRect();
    const mainPanel = mainPane.getBoundingClientRect();
    let  chatsPanelWidth = chatsPanel.width ;
    function mousemove(e) {
      let newX = prevX - e.x;
      chatsPanelWidth = Math.max(180,chatsPanel.width - newX);
      chatsPane.style.width = chatsPanelWidth + "px";
      currentChatSection.style.width = (mainPanel.width - chatsPanelWidth) + "px"
    }

    function mouseup() {
        const layout = getChatLayoutDimensions();
        setChatLayoutDimensions({
            ...layout,
            chats: chatsPanelWidth
        })
        window.removeEventListener('mousemove', mousemove);
        window.removeEventListener('mouseup', mouseup);

    }
  }




export function addPanelResizeEvents(){
    mainGutter.addEventListener('mousedown', mainPanelResizer);
    chatsGutter.addEventListener('mousedown', chatsPanelResizer);
}
